import React from "react";
const Footer = () => {
  return (
    <>
      <footer>
        <p>Copyright © Zonal DTP.</p>
      </footer>
    </>
  );
};

export default Footer;
